import { getLookupFromLocalStorage } from '../helpers/utils';
import local from '../../../local/ar';
import { yesOrNoEnum, yesOrNoEnumBoolean, applicantRole } from '@/helpers/enum';
export default {
  countries: getLookupFromLocalStorage('countries'),
  courts: getLookupFromLocalStorage('courts'),
  mergedActiveCourts: getLookupFromLocalStorage('mergedActiveCourts'),
  cities: getLookupFromLocalStorage('cities'),
  reconciliationLocations: getLookupFromLocalStorage('reconciliationLocations'),
  subCities: getLookupFromLocalStorage('subCities', true),
  districts: getLookupFromLocalStorage('districts', true),
  centers: getLookupFromLocalStorage('centers', true),
  regions: getLookupFromLocalStorage('regions'),
  caseTypesByCategory: {}, // getLookupFromLocalStorage('caseTypesByCategory', true),
  userCaseClassifications: [], // getLookupFromLocalStorage('userCaseClassifications'),
  subLanguages: [], // getLookupFromLocalStorage('subLanguages'),
  mainLanguages: [],
  mainSubLanguageDetails: {}, // getLookupFromLocalStorage('mainSubLanguageDetails', true),
  userCaseCategories: {}, // getLookupFromLocalStorage('userCaseCategories', true),
  userCaseTypes: {}, // getLookupFromLocalStorage('userCaseTypes', true),
  minorCases: getLookupFromLocalStorage('minorCases'),
  relatives: getLookupFromLocalStorage('relatives'),
  instrumentSources: getLookupFromLocalStorage('instrumentSources'),
  attachmentCategories: getLookupFromLocalStorage('attachmentCategories'),
  workPlaces: getLookupFromLocalStorage('workPlaces'),
  governmentAgencies: [], // getLookupFromLocalStorage('governmentAgencies'),
  associations: [], // getLookupFromLocalStorage('associations'),
  embassies: getLookupFromLocalStorage('embassies'),
  prisons: getLookupFromLocalStorage('prisons'),
  prisonerStatuses: getLookupFromLocalStorage('prisonerStatuses'),
  socialTypes: getLookupFromLocalStorage('socialTypes'),
  socialTypesWithCommercialReg: getLookupFromLocalStorage('socialTypesWithCommercialReg'),
  partyTypes: getLookupFromLocalStorage('partyTypes'),
  reasonsCaseClassification: getLookupFromLocalStorage('reasonsCaseClassification', true),
  cessationTypes: getLookupFromLocalStorage('cessationTypes'),
  allCourts: getLookupFromLocalStorage('allCourts'),
  partyReferences: getLookupFromLocalStorage('partyReferences'),
  sharedAssetTypes: [
    {
      id: 1,
      name: 'مال مشترك',
    },
    {
      id: 2,
      name: 'تركة',
    },
  ],
  sex: [
    {
      name: 'ذكر',
      id: 1,
    },
    {
      name: 'أنثى',
      id: 2,
    },
  ],
  attorneyTypes: [
    {
      id: 1,
      name: 'وكالة داخلية',
    },
    {
      id: 2,
      name: 'وكالة خارجية',
    },
  ],
  casePartyRole: [
    {
      name: 'مدعي',
      id: 1,
    },
    {
      name: 'مدعى عليه',
      id: 3,
    },
  ],
  appealType: [
    {
      name: 'مرافعة',
      id: 1,
    },
    {
      name: 'تدقيق',
      id: 2,
    },
  ],
  stopDurations: [
    {
      name: local.stopDurations.oneMonth,
      id: 1,
    },
    {
      name: local.stopDurations.twoMonths,
      id: 2,
    },
    {
      name: local.stopDurations.threeMonths,
      id: 3,
    },
    {
      name: local.stopDurations.fourMonths,
      id: 4,
    },
    {
      name: local.stopDurations.fiveMonths,
      id: 5,
    },
    {
      name: local.stopDurations.sixMonths,
      id: 6,
    },
  ],
  correctionOrInterpretationOfJudgmentRequestType: [
    {
      name: local.correctionOrInterpretationOfJudgmentRequestType.correctionRequestType,
      id: 1,
    },
    {
      name: local.correctionOrInterpretationOfJudgmentRequestType.interpretationRequestType,
      id: 2,
    },
  ],
  waiverOfAppealRequestResponse: [
    {
      name: local.waiverOfAppealRequestResponse.Approve,
      id: 1,
    },
    {
      name: local.waiverOfAppealRequestResponse.Reject,
      id: 2,
    },
  ],
  judgementCorrectionSections: [
    {
      name: local.judgementSections.waqae,
      id: 1,
    },
    {
      name: local.judgementSections.reasons,
      id: 2,
    },
    {
      name: local.judgementSections.mantoq,
      id: 3,
    },
  ],
  judgementInterpretationSections: [
    {
      name: local.judgementSections.waqae,
      id: 1,
    },
    {
      name: local.judgementSections.reasons,
      id: 2,
    },
    {
      name: local.judgementSections.mantoq,
      id: 3,
    },
    {
      name: local.judgementSections.other,
      id: 4,
    },
  ],
  yesNoOption: [
    {
      name: 'نعم',
      id: yesOrNoEnum.yes,
    },
    {
      name: 'لا',
      id: yesOrNoEnum.no,
    },
  ],
  yesOrNo: [
    {
      id: yesOrNoEnumBoolean.yes,
      name: 'نعم',
    },
    {
      id: yesOrNoEnumBoolean.no,
      name: 'لا',
    },
  ],
  typeOfContract: [
    {
      name: 'عقد إيجار موثق بين طرفين في شبكة إيجار',
      id: 1,
    },
    {
      name: 'تسجيل حالة تعاقدية (عقد مسجل من طرف واحد في شبكة إيجار)',
      id: 2,
    },
    {
      name: 'عقد ورقي أو اتفاق بين الطرفين',
      id: 3,
    },
  ],
  purposeOfTheLease: [
    {
      name: 'سكني',
      id: 1,
    }
    ,
    {
      name: 'غير سكني',
      id: 2,
    },
  ],
  partiesAuthenticationOptions: [
    {
      id: 0,
      name: 'إلغاء الطلب',
    }, {
      id: 1,
      name: 'قبول الطلب',
    }, {
      id: 2,
      name: 'تعديل الطلب',
    }],
  attorneyActionTypes: [
    {
      id: 1,
      name: local.attorney.updateAttorneyDetailsModalTitle,
    },
    {
      id: 2,
      name: local.attorney.DeleteTheAgencyOnThisCase,
    },
  ],
  representationTypes: [
    {
      id: 1,
      name: local.attorney.representative,
    },
    {
      id: 2,
      name: local.attorney.lawyer,
    },
  ],

  agreeNotAgree: [
    {
      id: 1,
      name: local.caseFile.lawsuitReplyForm.agree,
    },
    {
      id: 2,
      name: local.caseFile.lawsuitReplyForm.notAgree,
    },
    {
      id: 3,
      name: local.caseFile.lawsuitReplyForm.conditionallyAgree,
    },
    {
      id: 4,
      name: local.caseFile.lawsuitReplyForm.others,
    },
  ],
  additionalRequirement: [
    {
      id: 1,
      name: local.caseFile.lawsuitReplyForm.hasAdditionalRequirement,
    },
    {
      id: 2,
      name: local.caseFile.lawsuitReplyForm.hasNotAdditionalRequirement,
    },
  ],
  additionalRequests: [
    {
      id: 1,
      name: local.caseFile.lawsuitReplyForm.hasAdditionalRequests,
    },
    {
      id: 2,
      name: local.caseFile.lawsuitReplyForm.hasNotAdditionalRequests,
    },
  ],
  correctOrInCorrect: [
    {
      id: 1,
      name: local.caseFile.lawsuitReplyForm.correct,
    },
    {
      id: 2,
      name: local.caseFile.lawsuitReplyForm.inCorrect,
    },
    {
      id: 3,
      name: local.caseFile.lawsuitReplyForm.partiallyCorrect,
    },
    {
      id: 4,
      name: local.caseFile.lawsuitReplyForm.noAnswer,
    },
  ],
  acceptOrRefuse: [
    {
      id: 1,
      name: local.caseRelatedRequest.litigationAbandonmentsRequest.accept,
    },
    {
      id: 2,
      name: local.caseRelatedRequest.litigationAbandonmentsRequest.refuse,
    },
  ],
  courtSubCircles: getLookupFromLocalStorage('courtSubCircles', true),
  allCourtSubCircles: getLookupFromLocalStorage('allCourtSubCircles', true),
  rejectionReasons: getLookupFromLocalStorage('rejectionReasons', true),
  lawsuitEmployees: getLookupFromLocalStorage('lawsuitEmployees'),
  centralAuditEmployees: getLookupFromLocalStorage('centralAuditEmployees'),
  servicesCenterEmployees: getLookupFromLocalStorage('servicesCenterEmployees'),
  auditPaths: getLookupFromLocalStorage('auditPaths'),
  governmentalOrganizations: getLookupFromLocalStorage('governmentalOrganizations'),
  languages: getLookupFromLocalStorage('languages'),
  contractTypes: getLookupFromLocalStorage('contractTypes'),
  salaryPaymentIntervals: getLookupFromLocalStorage('salaryPaymentIntervals'),
  contractDropReasons: getLookupFromLocalStorage('contractDropReasons'),
  laborRequests: getLookupFromLocalStorage('laborRequests'),
  laborRequestFormFields: getLookupFromLocalStorage('laborRequestFormFields', true),
  laborEvidences: getLookupFromLocalStorage('laborEvidences'),
  laborEvidenceFormFields: getLookupFromLocalStorage('laborEvidenceFormFields', true),
  courtReplyTypes: getLookupFromLocalStorage('courtReplyTypes'),
  diplomaticAuthorities: getLookupFromLocalStorage('diplomaticAuthorities'),
  subAuthorities: getLookupFromLocalStorage('subAuthorities', true),
  centralAuthoritiesForMinistries: getLookupFromLocalStorage('centralAuthoritiesForMinistries', true),
  laborCities: [], // getLookupFromLocalStorage('laborCities'),
  caseRequestTypes: getLookupFromLocalStorage('caseRequestTypes'),
  criminalCaseTypes: getLookupFromLocalStorage('criminalCaseTypes'),
  allCaseTypes: getLookupFromLocalStorage('allCaseTypes'),
  portalPartyRoles: getLookupFromLocalStorage('portalPartyRoles'),
  portalRequestStatus: getLookupFromLocalStorage('portalRequestStatus'),
  decisionTypes: getLookupFromLocalStorage('decisionTypes'),
  laborCityCourt: {}, // getLookupFromLocalStorage('laborCityCourt', true),
  publicAndPersonalStatusCourts: getLookupFromLocalStorage('publicAndPersonalStatusCourts'),
  requestStatus: getLookupFromLocalStorage('requestStatus'),
  citiesByCourtType: [],
  cityCourtByType: {},
  criminalCityCourtByType: {},
  generalSpecializedLocationCourtOptions: [
    {
      id: 1,
      name: local.generalSpecializedLocationCourtOptions.conditionFound,
    },
    {
      id: 2,
      name: local.generalSpecializedLocationCourtOptions.PartiesCompanyRelated,
    },
    {
      id: 4,
      name: local.generalSpecializedLocationCourtOptions.PartiesGovernmentRelated,
    },
    {
      id: 3,
      name: local.generalSpecializedLocationCourtOptions.other,
    },
  ],
  partyRoles: [
    {
      id: 1,
      name: 'المدعي',
    },
    {
      id: 2,
      name: 'وكيل',
    },
    {
      id: 3,
      name: 'مدعى عليه',
    },
    {
      id: 5,
      name: 'محامى',
    },
    {
      id: 10,
      name: 'ممثل',
    },
    {
      id: 11,
      name: 'ولى',
    },
    {
      id: 20,
      name: 'المستأنف',
    },
    {
      id: 21,
      name: 'المستأنف ضده',
    },
  ],
  socialIdTypes: [
    {
      id: 1,
      name: 'هوية وطنية',
    },
    {
      id: 2,
      name: 'اقامة نظامية',
    },
  ],
  caseTypeTree: getLookupFromLocalStorage('caseTypeTree'),
  applicantRoles: [
    {
      name: local.applicantRoles.original,
      id: applicantRole.original,
    },
    {
      name: local.applicantRoles.representative,
      id: applicantRole.representative,
    },
  ],
  genders: [
    {
      id: 1,
      name: local.personInformation.male,
    },
    {
      id: 2,
      name: local.personInformation.female,
    },
  ],
  partyAttributesPartyRoles: getLookupFromLocalStorage('partyAttributesPartyRoles'),
  incomingRequestTypes: getLookupFromLocalStorage('incomingRequestTypes'),
  cassationRequestReasons: getLookupFromLocalStorage('cassationRequestReasons'),
};
